const FirebaseConfig = {
  apiKey: "AIzaSyBMCQ6VHAxQW9PVAlk0MOAmBd49Rz2eQPE",
  authDomain: "convey-dev-d0649.firebaseapp.com",
  projectId: "convey-dev-d0649",
  storageBucket: "convey-dev-d0649.appspot.com",
  messagingSenderId: "335854874075",
  appId: "1:335854874075:web:db018417a8648a39098bfe",
  measurementId: "G-G586F6SQC4"
};
export default FirebaseConfig;